/** Traductions éditoriales statiques ; les captures restent en français. */
import textes from './contenu-traduit.json'
export const CONTENU_TRADUIT: Readonly<
  Record<string, { readonly de: string; readonly en: string }>
> = textes
